import React from 'react';
import { ImageAsset, SVGAsset } from 'res';
import { Card, Transaction } from "model";
import { Link,useBCMSContext, useParams,BCMSRecord, BrandingImage } from "@bcm-dev/bcms-vite";
import "./styles.css";

/**
 * @function CardImageWidget
 * @param {STRING} CardBackground - This is the branded background for the cards.
 * @param {STRING} ProviderLogo - This is the logo of the provider.
 * @return {React.Component}
 * @exported true
 * @description This is the brandable preview card for each card in the dropdown
 * @example
 * <CardImageWidget cardBackground="backgroundAssetID" providerLogo="providerAssetID" />
 */
export default function CardImageWidget(props) {


  const globalController = useBCMSContext();

  const imageID = props.card.type == "debit" ? "dc_bgimage_chw23":"cc_bgimage_chw23";

  const cardBackground = props.card !== undefined ? (<BrandingImage id={imageID} className="set-width" />) : (<></>);
  let CreditProviderLogo =  globalController.state.branding.options.credit_provider_chw23 !== "Remove" && globalController.state.branding.options.credit_provider_chw23 !== "undefined"? (<ImageAsset id={globalController.state.branding.options.credit_provider_chw23 === "Visa"? "VisaLogo":"MastercardLogo"} className="set-width" />) : (<></>);
  let DebitProviderLogo =  globalController.state.branding.options.debit_provider_chw23 !== "Remove" && globalController.state.branding.options.debit_provider_chw23 !== "undefined" ? (<ImageAsset id={globalController.state.branding.options.debit_provider_chw23 === "Visa"? "VisaLogo":"MastercardLogo"} className="set-width" />) : (<></>);
  return (
    <div className="card-image-widget">
      <div className="image-container">
        {cardBackground}
      </div>
      <div className="provider-logo-container">
        {  props.card.type == "credit" && CreditProviderLogo}
        {  props.card.type == "debit" && DebitProviderLogo}
      </div>
    </div>
  );
}